import { connect } from 'formik';
import React from 'react';
import { Component, PropsWithChildren, Fragment } from 'react';
import { IBaseFormFieldProps, IStaticFieldProps } from '../Input';
import { resolveProps } from '../utils/formikUtils';
import { createId } from '../utils/IdGenerator';
import { InnerStaticFieldProps } from './types';

export class StaticField extends Component<PropsWithChildren<InnerStaticFieldProps>, {}> {
  private id = this.props.id || createId('staticField');
  public render() {
    const { id } = this;
    const { label = '', helpText } = this.props;
    const { value } = resolveProps(this.props, this.props.formik);

    return (
      <Fragment>
        {label && (
          <label className={'control-label'} htmlFor={id}>
            {label}
          </label>
        )}
        <p className={'form-control-static'} id={id}>
          {value}
        </p>
        {helpText && <p className="help-block">{helpText}</p>}
      </Fragment>
    );
  }
}

export default connect<IStaticFieldProps & IBaseFormFieldProps>(StaticField);
